// sapi-admin/src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // ✅ AJOUTER CETTE LIGNE

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

console.log('🔥 Firebase Admin Config (hardcoded):', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  appId: firebaseConfig.appId
});

let adminApp;
let auth;
let db;
let storage;
let functions; // ✅ AJOUTER CETTE VARIABLE

try {
  // Vérification SIMPLIFIÉE
  if (!firebaseConfig.apiKey) {
    throw new Error('API Key manquante dans la config');
  }
  
  // Initialisation
  adminApp = initializeApp(firebaseConfig, 'sapi-admin-app');
  console.log('✅ Firebase ADMIN app initialisée:', adminApp.name);
  
  // Services
  auth = getAuth(adminApp);
  db = getFirestore(adminApp);
  storage = getStorage(adminApp);
  functions = getFunctions(adminApp); // ✅ AJOUTER CETTE LIGNE
  
  console.log('✅ Services initialisés');
  console.log('✅ Auth:', !!auth);
  console.log('✅ DB:', !!db);
  console.log('✅ Functions:', !!functions);
  
} catch (error) {
  console.error('❌ Erreur d\'initialisation Firebase:', error);
  
  // Fallback
  auth = {
    currentUser: null,
    onAuthStateChanged: (callback) => {
      console.warn('Firebase ADMIN non initialisé - auth mock');
      return () => {};
    },
  };
  db = {};
  storage = {};
  functions = {}; // ✅ AJOUTER LE FALLBACK
}

export { adminApp, auth, db, storage, functions }; // ✅ EXPORTER functions
export default adminApp;